export function getBysideId () {
  const waitForPiwik = setInterval(() => {
    if (typeof window.bysideWebcare_get_visitor_UUID === 'function') {
      clearInterval(waitForPiwik)
      window.bysideId = window.bysideWebcare_get_visitor_UUID()
    }
  }, 50)
}

export function bysideIdToParam () {
  return `&byside=${encodeURIComponent(window.bysideId)}`
}
